module.exports = __webpack_public_path__ + "img/imagen8.695f322d.png";